import { useEffect, useState } from "react";
import { FaDownload } from "react-icons/fa";
import Button from "Components/UI/Button";
import Select from "Components/UI/Select";
import DetailSection from "Components/PatentDesign/DetailSection";
import FileList from "Components/PatentDesign/FileList";
import { disabledStyle, pdStyles } from "Components/PatentDesign/styles";
import { downloadPatentDesignRequestFile, updatePatentDesignRequest } from "JS/API";
import { detailPageStyles } from "utils/designSystem";
import usePatentDesignDownload from "utils/usePatentDesignDownload";
import {
  ERROR_MESSAGE,
  REQUEST_TYPE,
  REQUEST_TYPE_ORDER,
  UNASSIGNED_LABEL,
  formatDateTime,
} from "utils/patentDesign";

const thStyle = { ...detailPageStyles.td, ...detailPageStyles.tdTitle, textAlign: "left", width: "140px" };

const RequestInfoSection = ({ detail, onReload, onAlert, onError }) => {
  const savedType = detail.request_type || "";
  const [requestType, setRequestType] = useState(savedType);
  const [isSaving, setIsSaving] = useState(false);
  const { isDownloading, download } = usePatentDesignDownload({ onAlert, onError });

  useEffect(() => {
    setRequestType(savedType);
  }, [savedType]);

  const files = (detail.files || []).map((file) => ({
    id: file.id,
    name: file.original_file_name,
    size: file.file_size,
  }));
  const applicant = [detail.user?.name, detail.user?.email, detail.user?.phone]
    .filter(Boolean)
    .join(" · ");
  const isSaveDisabled = isSaving || requestType === savedType;

  const handleSave = async () => {
    if (isSaveDisabled) return;
    setIsSaving(true);
    try {
      const result = await updatePatentDesignRequest(detail.id, {
        request_type: requestType || null,
      });
      if (result && typeof result === "object") {
        onAlert("유형을 저장했습니다.");
        onReload();
      } else if (ERROR_MESSAGE[result]) {
        onAlert(ERROR_MESSAGE[result]);
      } else {
        onError(result);
      }
    } catch {
      onError();
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <DetailSection title="신청 정보">
      <div style={pdStyles.tableWrapper}>
        <table style={{ ...detailPageStyles.table, minWidth: 0 }}>
          <tbody>
            <tr>
              <th style={thStyle}>신청자</th>
              <td style={detailPageStyles.td}>{applicant || "-"}</td>
            </tr>
            <tr>
              <th style={thStyle}>신청일</th>
              <td style={detailPageStyles.td}>{formatDateTime(detail.created_at)}</td>
            </tr>
            <tr>
              <th style={thStyle}>
                <label htmlFor="patent-design-request-type">유형</label>
              </th>
              <td style={detailPageStyles.td}>
                <div style={pdStyles.row}>
                  <Select
                    id="patent-design-request-type"
                    value={requestType}
                    onChange={(e) => setRequestType(e.target.value)}
                    style={{ width: "180px" }}
                  >
                    <option value="">{UNASSIGNED_LABEL}</option>
                    {REQUEST_TYPE_ORDER.map((type) => (
                      <option key={type} value={type}>
                        {REQUEST_TYPE[type]}
                      </option>
                    ))}
                  </Select>
                  <Button
                    variant="secondary"
                    onClick={handleSave}
                    disabled={isSaveDisabled}
                    style={{ whiteSpace: "nowrap", ...disabledStyle(isSaveDisabled) }}
                  >
                    유형 저장
                  </Button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <h3 style={pdStyles.subTitle}>신청 내용</h3>
      <p style={pdStyles.content}>{detail.context}</p>

      <div style={pdStyles.subTitle}>
        <span>첨부 파일 ({files.length})</span>
        {files.length > 1 && (
          <button
            type="button"
            style={{ ...pdStyles.linkButton, ...disabledStyle(isDownloading) }}
            disabled={isDownloading}
            onClick={() => download(files, downloadPatentDesignRequestFile)}
          >
            <FaDownload size={11} />
            전체 다운로드
          </button>
        )}
      </div>
      <FileList
        files={files}
        disabled={isDownloading}
        onDownload={(file) => download([file], downloadPatentDesignRequestFile)}
      />
    </DetailSection>
  );
};

export default RequestInfoSection;
